import React from "react";
import MaskShapeContainer, {
  MaskType,
} from "../../MaskShapeContainer/MaskShapeContainer";

interface IContentCard {
  imageContent: React.ReactNode;
  textContent: React.ReactNode;
  imageContentStyle?: string;
  textContentStyle?: string;
  textContentBackground?: string;
  textContentMask?: React.SVGAttributes<SVGElement>;
  textContentMaskId?: string;
  className?: string;
  maskType?: MaskType;
}

const ContentCard = ({
  imageContent,
  textContent,
  imageContentStyle,
  textContentStyle,
  textContentBackground,
  textContentMask,
  textContentMaskId,
  className,
  maskType,
}: IContentCard) => {
  return (
    <>
      <div className={`w-full h-full relative  ${className}`}>
        <div className={`z-0 w-full absolute top-0 ${imageContentStyle}`}>
          {imageContent}
        </div>

        <div className={`z-20 w-full absolute bottom-0 ${textContentStyle}`}>
          {textContent}
        </div>

        {/* Backwark implementation */}
        {maskType ? (
          <MaskShapeContainer
            maskType={maskType}
            className={`z-10 w-full absolute bottom-0 ${textContentStyle} ${textContentBackground}`}
          />
        ) : (
          <div
            className={`z-10 w-full absolute bottom-0 ${textContentStyle} ${textContentBackground}`}
            style={{ clipPath: `url(#${textContentMaskId})` }}
          />
        )}
      </div>
      {textContentMask}
    </>
  );
};

export default ContentCard;
